<template>
  <div class="product-card-box">
    <div class="header-box">
      <div class="header-left">
        <div class="header-title">{{ title }}</div>
        <slot name="header-left"></slot>
      </div>
      <div class="header-right">
        <slot name="header-right"></slot>
      </div>
    </div>
    <div class="content-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.product-card-box {
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
  background: #fff;
  border-radius:2px;
  margin-top: 12px;
  .header-box {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-left {
      display: flex;
      align-items: center;
      .header-title {
        color: #2F333D;
        font-size: 20px;
        line-height: 1;
        font-weight: 600;
        position: relative;
        z-index: 1;
        &::after{
          content: "";
          position: absolute;
          left: 0;
          bottom: -2px;
          z-index: -1;
          width:48px;
          height:6px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
          opacity:0.6;
        }
      }
    }
    
    .header-right {
      display: flex;
      align-items: center;
    }
  }
  .content-box {
    padding: 0 16px 16px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/product-card-box.vue